module.exports = __webpack_public_path__ + "img/Hotel-Olive-Downtown.faed810e.jpg";